import { ValidatorRule } from 'rc-field-form/lib/interface';
import { tryParseJsonObject } from '../utils/common-utils';

export const jsonValidator: ValidatorRule['validator'] = (rule, value) =>
  !value || tryParseJsonObject(value) ? Promise.resolve() : Promise.reject('Should be valid JSON object');
